import ListPageLayout from "../../componets/layout/ListPageLayout";
import vehiclesApi from "../../services/vehiclesApi";

export default function Vehicles() {
    return(

        <ListPageLayout
            title={'Lista Veículos'}
            urlCreate={'/veiculos/formulario'}
            vehicles
            table={
                {
                    loader: vehiclesApi.all,
                    columns: [
                        { label: "Marca", index: "marca", type: 'string'},
                        { label: "Modelo", index: "modelo", type: 'string'},
                        { label: "Ano", index: "ano", type: 'string'},
                        { label: "Valor", index: "valor", type: 'value'},
                    ]
                }
            }
        />
    )
}